export default {
  APP: {
    CLOSE: 'Close',
    DETAIL: 'Detail',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    BACK: 'Back',
    ADD: 'Add',
    CHANGE_SERVER: 'Change server',
    CURRENT_SERVER: 'current server',
    NEW_SERVER: 'New server',
    REQUIRED: 'Required.',
    CANNOT_CONNECT_TO: 'Cannot connect to',
    DO_YOU_STILL_WANT_TO_CONTINUE: 'Do you still want to continue?',
    LANGUAGE: 'Language:',
    WARNING: 'Warning',
    YES: 'Yes',
    SSL_SETTING: 'Ignore SSL certificate check',
    USE_BYPASS_CHANNEL: 'Use fallback channel',
    FEEDBACK_TITLE: 'Help us improve your experience on M-Suite',
    FEEDBACK_CONTENT: 'Your feedback on this quick 2-minute survey will help us improve our ability to serve you and other M-suite users',
    MAYBE_LATER: 'Maybe later',
    START_NOW: 'Start now',
    CONTINUE: 'Continue',
    CHECKING: 'Checking...',
    WELCOME: 'Welcome',
    VIEW_DETAIL: 'View detail',
    COPIED: 'Copied to clipboard',
    RATING: 'How do you rate our app?',
    THANKS: 'Thank you for your feedback!',
    DELETE: 'Delete',
    DELETE_REG: 'Delete',
    NOTIFICATION: 'Notification',
    LOADING: 'Loading applications...',
    UPDATE: 'Update',
    UPDATE_APP: 'Update app',
    HAVE_NEW_VERSION: 'A new version is available: {version}',
    PLEASE_CLICK_UPDATE_TO_UPDATE_NEW_VERSION: {
      1: 'Please click the',
      2: 'Update',
      3: 'button to download and install the new version.',
    },
    DIRECT_ACCESS_APP: "Direct access application",
    DIRECT_ACCESS_APP_TOOLTIP: "Applications can be opened by clicking directly.",
    INTERMEDIATE_ACCESS_APP: "Intermediate access application",
    INTERMEDIATE_ACCESS_APP_TOOLTIP: "Applications are specially configured and cannot be opened directly. They require access through an intermediary application or other specific access methods.<br>For more information, please contact the support.",
    SELECT_SERVER_DESC: "Please select a server from the list below:",
    CONNECTING: "Connecting",
    LOGIN_STEP_DESC: "The login step will be skipped if the session on the selected server is still valid.",
    ERROR_INTERNET_COMMON: {
      1:"A connection error has occurred.",
      2: "Please check your Internet connection or contact your administrator."
    },
    APP_DISCONNECTED: {
      1: "M-Suite disconnected",
      2: "Switch on the connection to access the applications"
    }
  },
  LOGIN: {
    FIRST_TIME_SUB_TITLE: 'Please enter your M-Suite domain name',
    SELECT_SERVER: 'Select server',
    ADD_SERVER: 'Add server',
    SERVER_NAME: 'Server name',
    SERVER: 'Server',
    LOADING_DATA: 'Retrieving data',
    SELECT_LOGIN_TYPE: 'Login method',
    ACCOUNT_MSUITE: 'M-Suite account',
    FORGOT_PASSWORD: 'Forgot Password?',
    FORGOT_PASSWORD_TITLE: 'Recover Account',
    SELECT_MFA: 'SELECT AUTHENTICATION METHOD',
    AUTH_METHOD: 'Authentication method',
    CODE_NOT_RECEIVED: 'Did not get a code?',
    RESEND: 'Resend',
    ERROR_SERVER: 'Invalid server name',
    SERVER_EXIST: 'Server name existed',
    LOGIN_OPTIONS: 'Login options',
    TWO_FACTOR_AUTHENTICATION: '2-factor authentication',
    VERIFY_CURRENT_SESSION: 'Verify current session',
    ENTER_USERNAME_RECOVER: 'Enter your username',
    USERNAME: 'Username',
    ENTER_USERNAME_FORGOT_PASSWORD: 'Enter your username',
    CHANGE_PASSWORD_FOR_ACCOUNT: 'Enter your new password:',
    GO_TO_LOGIN_PAGE: 'Go to login page',
    BACK_TO_LOGIN_PAGE: 'Back to Login Page',
    HAD_LOGIN_SESSION: 'You still have the previous login version at this server. Do you want to continue?',
    SHOW_PASS: "Show password",
    HIDE_PASS: "Hide password",
  },
  LAYOUT: {
    CANCEL: "Cancel",
    CHECK_FOR_UPDATES: "Check for updates",
    CONFIRM: 'Confirm',
    CONFIRM_EXIT: "Confirm exit",
    CONFIRM_LOGOUT: "Confirm logout",
    CONFIRM_LOGOUT_ALL_DEVICE: "Notification",
    CONNECTION: "Connection",
    CONNECTIVITY_LOST: "Connectivity lost",
    DO_YOU_REALLY_WANT_TO_EXIT_THIS_APP: "Do you really want to \n exit?",
    DO_YOU_REALLY_WANT_TO_EXIT_THIS_PAGE: "Do you really want to exit this page?",
    DO_YOU_REALLY_WANT_TO_LOGOUT_ALL_DEVICES: "Do you really want to \n logout on all devices (except this device)?",
    DO_YOU_REALLY_WANT_TO_LOGOUT_THIS_APP: "Do you really want to \n logout?",
    DO_YOU_WANT_TO_LOGOUT_THIS_DEVICE: "Do you want to log out this device?",
    EXIT: "Exit",
    FEEDBACK: "Feedback",
    GUIDE: "GUIDE",
    LOGOUT: "Logout",
    LOGOUT_ALL: "Logout all",
    LOG_OUT_ALL_DEVICES: "Log out on all devices",
    NOTIFICATION: "Notification",
    OPTIONS: "Options",
    SETTING: "Settings",
    TROUBLESHOOTING_GUIDE: "Troubleshoot Guide",
    USER_GUIDE: "User Guide",
    ONLINE: "Online",
    EXPIRED_TOKEN_CONTENT: "You are logged out of the current session",
    BACK_TO_LOGIN_PAGE_AFTER: 'Back to Login Page ({second}s)',
    QRCODE_EXPIRED: "QR code expired",
    RELOAD_QRCODE: "QR code will now be reloaded,",
  },
  APPLICATIONS: {
    LIST_APPS: 'List Applications',
    RECENT_APPS: 'Recent app',
    SEARCH_RESULT: 'Search result',
    NO_SEARCH_RESULT: 'No application found',
    TRY_WITH_OTHER_KEYWORD: 'Try searching with different keywords',
    APP_BLANK: 'No application available',
    START_ALL_APP: 'Start all applications',
    CLOSE_ALL_APP: 'Close all applications',
    SEARCH_APPS: "Search apps",
    LOADING: 'Loading'
  },
  SCAN_DEVICE: {
    DEVICE_POLICY: 'Device safety policy',
    ISSUE: 'issue(s)',
    NO_ISSUES: 'No issues detected',
    DETECTED_ISSUES: 'Detected {issues} issue(s)',
    SCAN: 'Scan',
    SCANNING: 'Scanning',
    VIEW_DETAIL: 'View detail'
  },
  POLICIES_BASELINES: {
    STEP: 'Step',
    SKIP_ACTION: 'Skip',
    SCAN_DEVICE: 'Scan device',
    NOTE: 'Note',
    NOTE_CONTENT: 'Baseline resolved? \n Please scan your device to update.',
    SCANNING: 'Scanning',
    BLOCK_NET_POLICY: "Block network policy",
    BLOCK_NET_POLICY_DESC_1: "Important applications will have the <b>Block network policy</b> applied when enabled, to minimize potential risks and enhance the overall system security.",
    BLOCK_NET_POLICY_DESC_2: "To restore normal Internet access, please disconnect all applications with the <b>Block network</b> icon.",
  },
  SDP_APP: {
    ACCEPT: "Allowed",
    APP_NAME: "App name",
    APP_STATUS: "Status",
    AUTO_START_ALL_APP_AFTER_LOGIN_DESC: "Automatically open access to all apps in the list after logging into M-Suite.",
    BASELINE_ISSUE: "Baseline issues",
    BASELINE_ISSUE_ALERT: "Device baseline violated",
    BASELINE_ISSUE_SUB_TITLE: "You may not be able to open some apps due to violated baseline(s). Please follow instruction to resolve this issue or contact admin for support",
    BLOCK_NETWORK: "Block network",
    DISABLE_CLIPBOARD: "Block clipboard",
    DISABLE_DOWNLOAD: "Block download",
    DISABLE_PRINT: "Block printing",
    CLICK_TO_OPEN: "Click to open app",
    CLOSE_APP_CONNECTION: "Close connection",
    CLOSE_STATUS: "Closed",
    CONNECT_PERMISSION: "Access",
    CONNECT_REQUEST: "Access request",
    DECLINE: "Not allowed",
    DETAILS_GUIDELINE: "Detailed guideline",
    DOMAIN: "Domain/IP",
    EXPIRED_TIME: "Session timeout",
    EXPLAIN_CAN_NOT_RESOLVE_APP_PART_1: "Some rules of baseline are not compatible with the OS on your device so we are unable to synchronize the resolution of the related issue.",
    EXPLAIN_CAN_NOT_RESOLVE_APP_PART_2: "Please contact Administrator for more details.",
    GO_TO_SETTINGS: "Go to settings",
    HAS_BASELINE_ISSUE: "Access blocked due to baseline violation.",
    MESSAGE_REQUEST_CONNECT: "Message",
    MESSAGE_TO_ADMINISTRATOR: "Message to system admin is required",
    NEED_APPROVED_MESSAGE: "You need admin's approval to access this application.",
    NO_APPROVE_CONNECT_YET: "Access request not approved yet",
    OPENING_CONNECTION: "Opening connection...",
    OPEN_APP_CONNECTION: "Open connection",
    OPEN_STATUS: "Opening",
    PENDING_APPROVED_MESSAGE: "Access request sent. Please wait for your admin to approve.",
    POLICIES: "Policies",
    REFRESH_APPS: "Refreshing application list",
    REJECT_APP: "Your access request has been declined",
    RENEW_APP_LIST: "Refresh application list",
    REQUEST_CONNECT: "Access request",
    RESOLVE: "Resolve",
    SEND_REQUEST: "Send request",
    SEND_REQUEST_CONNECT_APP: "Send access request",
    START_ALL_AFTER_LOGIN: "Launch all applications after login",
  },
  ACCOUNT: {
    ACCOUNT_INFO: 'Account info',
    ACCOUNT_DETAILS: 'Account details',
    DISPLAY_NAME: 'Display name',
    EMAIL: 'Email',
    PHONE_NUMBER: 'Phone number',
    USER_ID: 'User ID',
    CLIENT_ID: 'Client ID',
  },
  DEVICE: {
    DEVICE_ID: 'Device ID',
  },
  VERIFY_CURRENT_SESSION: {
    PLEASE_WAIT_FOR_A_WHILE: 'Please wait for a while',
    CHANGE_SERVER: 'Change server',
    CONNECTING_TO_SERVER: 'There may have some troubles when connecting to server',
    CONNECTIVITY_LOST: 'Connectivity lost',
    SOMETHING_WENT_WRONG: 'Something went wrong!',
    TRY_CONNECTING_TO: ' Try connecting to'
  },
  USERNAME_PASSWORD: {
    USERNAME: 'Username',
    PASSWORD: 'Password',
    OTP: 'OTP',
    NEW_PASSWORD: 'New password',
    ENTER_NEW_PASSWORD: 'Enter new password',
    ENTER_NEW_PASSWORD_AGAIN: 'Re-enter new password',
    REQUIRED: 'Required.',
    CANNOT_CONNECT_TO: 'Cannot connect to',
    DO_YOU_STILL_WANT_TO_CONTINUE: 'Do you still want to continue?',
    LOGIN: 'Login',
    CONFIRM_PASSWORD_NOT_VALID: 'Passwords do not match',
    PASSWORD_RULES_TITLE: 'Password must satisfy following conditions:',
    PASSWORD_RULES: {
      AT_LEAST_8_CHARACTERS: 'At least 8 characters in length.',
      AT_LEAST_A_LOWERCASE: 'Contain at least 1 lowercase letter (a-z)',
      AT_LEAST_A_UPPERCASE: 'Contain at least 1 uppercase letter (a-z)',
      AT_LEAST_A_NUMBER: 'Contain at least a number (0-9)',
      AT_LEAST_A_SPECIAL_CHARACTER: 'Contain at lease 1 special character (! @ # $ % ...).'
    },
    CHANGE_PASSWORD_SUCCESS: 'Password changed successfully',
    ENTER_PASSWORD_TO_CONFIRM: 'Please confirm by entering password',
    PASSWORD_INCORRECT: 'Authentication information is incorrect'
  },
  TOTP: {
    CLICK_TO_QR_CODE: "Click on QR code to display",
    SETUP_KEY: "Setup key",
    SETTING_TOTP: 'Configurate TOTP',
    SETTING_TOTP_CODE: 'TOTP setup code',
    SETTING_TOTP_CODE_NODE: 'Note: DO NOT share your code to anybody.',
    CODE: 'TOTP setup code',
    SETTING_TOTP_CONTENT: {
      1: 'You will receive a code via a third-party application (Google Authenticator, Microsoft Authenticator, etc.)',
      2: 'To use this authentication method, you need to do the initial setup only once(except for cases of creating a new M-Suite account or changing/reinstalling the TOTP application)'
    },
    INTRO_SETTING_TOTP: 'TOTP configuration guide',
    COPY: 'Copy',
    COPIED: 'Copied to clipboard',
  },
  PREPARE: {
    RETRY: 'Retry',
    CONNECTIVITY_LOST: 'Connectivity lost',
    BACK_TO_LOGIN: 'Back to Login',
    CHANGE_SERVER: 'Change Server',
    AUTHENTICATING: 'Authenticating',
  },
  OTP: {
    NEXT: 'Next',
  },
  ENROLLMENT_WAIT: {
    CONFIRM_MESSAGE: 'Do you want to cancel this request?',
    CONFIRM_TITLE: 'Confirm Cancel Request',
    NO: 'No',
    YES: 'Yes',
    LOGOUT_CONFIRM_MESSAGE: 'Do you want to logout?',
    LOGOUT_CONFIRM_TITLE: 'Confirm Logout',
    CANCEL: 'Cancel',
    LOGOUT: 'Logout',
    ENTER_OTP_FOR_AUTO_APPROVED: "Enter OTP for auto approved",
    RESEND: "Resend",
    WAIT_APPROVE: 'Waiting for approval',
    WAIT_APPROVE_CONTENT: 'Your registration request has been sent to System admin. Please wait for admin\'s approval.'
  },
  ENROLLMENT_LAYOUT: {
    REGISTER_CONNECT: 'Register device'
  },
  ENROLLMENT_RESULT: {
    REGISTRATION_DENIED: 'Registration Denied!',
    YOUR_REGISTRATION_HAD_BEEN_DENIED: 'Your registration had been denied.',
    REQUEST_AGAIN: 'Request again',
    AUTHEN_DEVICE_FAILED: 'A device validating issue occurred',
    RESOLVE: 'To resolve the problem, please try:',
    RESOLVE_CONTENT_1: 'Closing M-Suite app on system tray and reopen it',
    RESOLVE_CONTENT_2: 'or Restarting your computer',
    RESOLVE_CONTENT_3: 'If the error still occurred after a few attempts, contact your System admin for support',
    RESOLVE_CONTENT_4: 'To register this device again, click ',
    RESOLVE_CONTENT_LINK: 'here.',
    EXIT_APP: 'Exit application',
  },
  ENROLLMENT_PREPARE: {
    EMAIL: 'Email',
    DEVICE_NAME: 'Device name',
    IDENTITY_DEVICE: 'Device identity',
    MESSAGE: 'Message',
    REGISTER: 'Register',
    DOMAIN: 'Domain',
    TIME: 'Time',
    HIDE_DETAILS: 'Hide detail',
    SHOW_DETAILS: 'Show detail',
  },
  COMMON_LOCAL_APP_CONNECT: {
    OVERTIME: 'App may have been closed. Please close this window / browser tab.\n' + '        Thanks!',
  },
  COMMON_LOCAL_SERVICE_CONNECT: {
    LINUX_COMMAND: 'Try this command on admin console to fix the issue',
    CLICK_TO_RESOLVE: 'Click to resolve',
    NOTE: 'Note',
    CONFIRM_CONTENT: 'New window will be open. You may need to have administrator permission to resolve the issue.',
    VIEW_DETAIL_GUIDELINE: 'View detail guideline',
    I_UNDERSTOOD_CONTINUE: 'I understood & continue',
    THERE_MAY_HAVE_SOME_TROUBLES_FROM_SERVICE_PROCESS: 'There may have some troubles from service process'
  },
  USER_GUIDE: {
    TABLE_OF_CONTENT: 'Table of content',
    CONTACT_US: 'Contact us',
    SEARCH_PLACEHOLDER: 'Search by keyword...',
    SEARCH_RESULT_FOR: 'Search result for',
    NO_DATA: 'No matching results found',
    CONTACT_TITLE: 'Contact System Admin',
    CONTACT_CONTENT: 'Got a problem that need support? Please contact your admin via phone or email:',
    CONTACT_EMAIL: 'Email',
    CONTACT_PHONE: 'Phone number',
  },
  ERROR_SERVICE: {
    ERROR_SERVICE_HOST_NAME: 'Cannot resolve host name. Please check your internet connection',
    ERROR_SERVICE_SDP_DISCONNECT: 'Unable to connect to the server. Please check your internet connection',
    ERROR_SERVICE_CONNECT_TIMEOUT: 'Connect timeout. Please check your internet connection',
    ERROR_SERVICE_GENERAL: "An error occurred. Please try again after few minutes",
    ERROR_DETAIL: "Error detail",
    ERROR_GATEWAY: "Connection to gateway failed",
    ERROR_BASELINE: "Access blocked due to baseline violation.",
    ERROR_MAX_CHARACTER: "{name} must not contain more than {max} characters",
    ERROR_SSL_EXPIRED: "SSL cert unavailable or expired",
    ERROR_UPDATE: "An error occurred. Cannot update application"
  },
  COUNT_DOWN: {
    REMAINING_DURATION_TEXT: 'Access expired'
  },
  OPTIONS: {
    // MENU
    LABEL: 'Preferences',
    SERVER: 'Server',
    SERVER_CONFIG: 'Server config',
    VERSION: 'Version',
    DEVICES_MANAGEMENT: 'Devices management',
    CONTACT_AND_SUPPORT: 'Contact & Support',
    FEEDBACK: 'Feedback',
    OTHERS: 'Other',
    LANGUAGE: 'Language',
    LOGOUT: 'Logout',
    EXIT: 'Exit',
    // FEEDBACK
    YOUR_OPINION: 'Your opinion',
    YOUR_OPINION_REQUIRED: 'Please enter your opinion',
    FEEDBACK_DESC: 'Our team value every feedback on our product. All of your feedback will be carefully noted, and we aim to use it to continually improve the product.',
    SEND_FEEDBACK: 'Send feedback',
    SEND_FEEDBACK_SUCCESS: 'Feedback sent successfully',
    SEND_OTHER_FEEDBACK: 'Send another feedback',
    // UPDATE
    UPDATE_APP: 'Update',
    NEW_UPDATE_AVAILABLE: 'New version is available',
    CURRENT_VERSION: 'Current version',
    UPDATED_APP: 'Application updated',
    UPDATING_APP: 'Downloading',
    UPDATING_APP_DESC: 'M-Suite is still available to use while downloading is in progress.',
    STOP_UPDATE: 'Stop updating',
    CHECK_UPDATE: 'Check for updates',
    CHECKING_UPDATE: 'Checking for updates',
    UPDATE_NOW: 'Update now',
    UPDATE_CLOSE_BLOCK_NETWORK_APP_INTRO: 'To be able to check and update the version, it is necessary to close access to applications with a blocking policy Internet.',
    UPDATE_DETAILS: "UPDATED DETAILS:",
    // LANGUAGE
    CHOOSE_LANGUAGE: 'Choose language',
    UPDATE_LANGUAGE: 'Update language',
    // DEVICES
    DEVICE: 'Device',
    NAME: 'Name',
    OS: 'OS',
    REGISTRATION_DATE: 'Registration date',
    LAST_LOGIN: 'Last login',
    DELETE_CONNECTION: 'Delete registered device',
    DEVICE_INFO: 'Device information',
    LOGOUT_ALL_DEVICES: 'Logout all devices',
    THIS_DEVICE: 'This device',
    OTHER_DEVICES: 'Other Devices',
    RE_LOGIN_AFTER_CHANGE_SERVER: 'You may need to log in again after changing servers',
    DELETE_CONNECTION_DESC: 'Device\'s connection permissions to all servers will be deleted.',
    CANCEL_CONNECT_PERMISSION_DEVICE: "This device’s enrollment on domain: {domainName} will be deleted.",
    DO_YOU_WANT_TO_LOGOUT_THIS_DEVICE: "Do you want to log out this device?",
    //SUPPORT
    EMAIL: "Email",
    CONTACT: "Support hotline",
    INSTRUCTIONS: "Instructions",
    INSTRUCTIONS_FOR_USE: "Instructions for use",
    TROUBLESHOOTING_GUIDE: "Troubleshooting guide",
  },
  BASELINE: {
    BASELINE_DESC: "The Device Safety standards below are specified by the Administrator to ensure the safety of the internal system when connecting remotely.",
    ONLY_SHOW_TEXT: "Only violation criteria are displayed"
  }
}
